// extracted by mini-css-extract-plugin
export default {"table_text":"DeviceModal_table_text__jQW8S","red":"DeviceModal_red__TolGA"};